import Vue from 'vue';
import axios from './router/axios';
import VueAxios from 'vue-axios';
import App from './App';
import './permission'; // 权限
import './error'; // 日志
import router from './router/router';
import 'avue-plugin-transfer/packages' //引入avue-plugin-transfer插件
import store from './store';
import htmlToPdf from '@/utils/htmlToPdf';
Vue.use(htmlToPdf);

import {
    loadStyle
} from './util/util'
import * as urls from '@/config/env';
import {
    iconfontUrl,
    iconfontVersion
} from '@/config/env';
import * as filters from './filters' // 全局filter
import './styles/common.scss';
// 引入avue的包
import '@smallwei/avue/lib/index.js';
// 引入avue的样式文件
import '@smallwei/avue/lib/theme-chalk/index.css';
import basicContainer from './components/basic-container/main'
import VueClipboard from 'vue-clipboard2'
// 插件 json 展示
import vueJsonTreeView from 'vue-json-tree-view'

// 引入ueditor
import 'avue-plugin-ueditor/packages'
import avueUeditor from 'avue-plugin-ueditor/packages'
Vue.component('avueUeditor', avueUeditor)
// 引入v-viewer
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

// 引入高德地图插件
import AvueMap from 'avue-plugin-map/packages'
Vue.use(AvueMap);
Vue.prototype.$axios = axios;

Vue.use(Viewer,{
    defaultOptions: {
        zIndex: 9999999
    }})
Vue.use(VueClipboard)

Vue.use(vueJsonTreeView)

Vue.use(VueAxios, axios)

Vue.component('basicContainer', basicContainer)

Object.keys(urls).forEach(key => {
    Vue.prototype[key] = urls[key];
})

Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

iconfontVersion.forEach(ele => {
    loadStyle(iconfontUrl.replace('$key', ele));
})

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')